import { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import Header from './Header';
import HomeRedirect from 'app/components/HomeRedirect';
import TwoFactorAuthentication from 'app/screens/Login/TwoFactorAuthentication';

import {
  login
} from 'shared/actions/userActions';

import {
  home as homePath,
  passwordReset as passwordResetPath
} from 'app/routes';

const Login = props => {
  const {
  } = props;

  const [state, setState] = useState({
    submitting: false,
    error: null,
    emailError: false,
    passwordError: false
  });

  const emailRef = useRef('');
  const passwordRef = useRef('');

  const user = useSelector(state => state.userReducer.user);
  const dispatch = useDispatch();
  const history = useHistory();

  const onEmailChange = event => {
    emailRef.current = event.target.value
  }

  const onPasswordChange = event => {
    passwordRef.current = event.target.value;
  }

  const onSubmit = async event => {
    event.preventDefault();

    let missingEmail = !emailRef.current
    let missingPassword = !passwordRef.current
    let error = missingEmail || missingPassword;

    if (error) {
      setState(state => ({
        ...state,
        emailError: missingEmail,
        passwordError: missingPassword,
        error: "Oops, looks like you're missing something."
      }));
    } else {
      setState(state => ({
        ...state,
        submitting: true,
        error: null
      }));

      try {
        await dispatch(login(emailRef.current, passwordRef.current));

      } catch (err) {
        setState(state => ({
          ...state,
          error: err.error,
          submitting: false
        }));
      }
    }
  }

  if (user) {
    if (!user.enable_mfa) {
      return <HomeRedirect />
    } else {
      return <TwoFactorAuthentication providedEmail={emailRef.current} providedPass={passwordRef.current}/>
    }
  }

  return (
    <Form className="login-form" onSubmit={onSubmit}>
      <Header />
      <h2>Login</h2>
      {state.error && <p className="error">{state.error}</p>}
      <Form.Group>
        <Form.Label htmlFor="email">Email</Form.Label>
        <Form.Control className={state.emailError ? 'error' : ''}
          type="email"
          name="email"
          placeholder="Email"
          onChange={onEmailChange}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label htmlFor="password">Password</Form.Label>
        <input className={state.passwordError ? 'error' : ''}
          type="password"
          name="password"
          placeholder="Password"
          onChange={onPasswordChange}
        />
        <button type="button" className="forgot-btn" onClick={() => history.push(passwordResetPath)}>Forgot?</button>
      </Form.Group>
      <Button variant="primary" className="bs-btn bs-btn-primary full-width" type="submit">
        <span>{state.submitting ? 'Logging in...' : 'Login'}</span>
      </Button>
      <p style={{display: 'none'}} className="terms">By using Capturelife you agree to our <a href="https://capturelife.com/terms"  target="_blank">terms of use</a>.</p>
    </Form>
  )
}

export default Login;
